export const api = {
  viewReceiptsUrlFn: (companyId: string, includeReceiptDetails?: boolean) =>
    `POReceipt/Filter?companyId=${companyId}&includeReceiptDetails=${!!includeReceiptDetails}`,
  viewReceiptDeleteUrl: 'Receipt/Delete',
  viewReceiptUndeleteUrl: 'Receipt/Undelete',
  viewReceiptCancelUrlFn: (receiptId: string) => `Receipt/${receiptId}/Cancel`,
  reopenReceipt: 'Receipt/ReOpen',
  getInvoiceDataUrlFn: (companyId: string) => `Invoice/Filter?companyId=${companyId}`,
  getInvoiceUploadS3UrlFn: () => 'Invoice/S3UploadUrl',
  getReceiptUploadS3UrlFn: () => 'Receipt/S3UploadUrl',
  getScanInvoiceDataUrlFn: (companyId: number, uploadsOlderThan90Days?: boolean) =>
    `Invoice/Attach/Filter?companyId=${companyId}&uploadsOlderThan90Days=${uploadsOlderThan90Days}`,
  getScanReceiptDataUrlFn: (companyId: number) => `Receipt/Attach/Filter?companyId=${companyId}`,
  getScanManagerInvoiceRecords: 'Invoice/Attach/Filter',
  getScanManagerReceiptRecords: 'Receipt/Attach/Filter',
  uploadScanManagerInvoiceRecordFn: (companyId: number, id?: number) =>
    id
      ? `Invoice/Attach?companyId=${companyId}&invoiceId=${id}`
      : `Invoice/Attach?companyId=${companyId}`,
  deleteScanManagerInvoiceRecord: 'Invoice/Attach/Delete',
  checkInvoiceNumber: (invoiceId: string) => `Invoice/${invoiceId}/CheckDuplicateInvoiceNumber`,
  deleteScanManagerReceiptRecord: 'Receipt/Attach/Delete',
  uploadScanManagerReceiptRecordFn: (companyId: number, id?: number) =>
    id
      ? `Receipt/Attach?companyId=${companyId}&receiptId=${id}`
      : `Receipt/Attach?companyId=${companyId}`,
  poDetails: (poId: string) => `/PO/${poId}`,
  filterPo: (companyId: string, itemNumber?: string) =>
    `po/filter?companyId=${companyId}&itemNumber=${itemNumber}`,
  getOfflineSuppliers: 'supplier/offline',
  receiptDetails: (receivingReceiptId: string) => `Receipt/${receivingReceiptId}`,
  getReceiptDataUrlFn: (companyId: number) => `Receipt/Attach/Filter?companyId=${companyId}`,
  viewInvoicesUrlFn: (companyId: string) => `POInvoice/Filter?companyId=${companyId}`,
  deleteInvoice: 'Invoice/Delete',
  undeleteInvoice: 'Invoice/Undelete',
  isDuplicateApId: (poId: string) => `PO/${poId}/isDuplicateApId`,
  isDuplicateSupplierName: (poId: string) => `PO/${poId}/isDuplicateExternalSupplierName`,
  cancelInvoice: 'Invoice/Cancel',
  completeInvoice: 'Invoice/Complete',
  cancelReceipt: 'Receipt/Cancel',
  completeReceipt: 'Receipt/Complete',
  closePO: 'PO/Close',
  cancelPO: 'PO/Cancel',

  getReceiptDataUrlGenerator: (receivingReceiptId: number) => `Receipt/${receivingReceiptId}`,
  getInvoiceDataUrlGenerator: (receivingInvoiceId: number) => `Invoice/${receivingInvoiceId}`,
  addAttachmentsToInvoiceFn: (invoiceId: number) => `Invoice/${invoiceId}/Attach`,
  getInvoiceAttachments: (invoiceId: number) => `Invoice/${invoiceId}/Attach`,
  addAttachmentsToReceiptFn: (receiptId: number) => `Receipt/${receiptId}/Attach`,
  unAttachReceiptUrlFn: (receiptId: number, attachId: number) =>
    `Receipt/${receiptId}/UnAttach?attachId=${attachId}`,
  unAttachInvoiceUrlFn: (invoiceId: number, attachId: number) =>
    `Invoice/${invoiceId}/UnAttach?attachId=${attachId}`,
  changeInvoiceDocumentName: 'Invoice/Attach/Rename',
  changeReceiptDocumentName: 'Receipt/Attach/Rename',
  deleteAttachmentOfReceiptIdFn: (receiptId: number) =>
    `Receipt/Attach/Delete?receiptId=${receiptId}`,
  deleteAttachmentOfInvoiceIdFn: (invoiceId: number) =>
    `Invoice/Attach/Delete?invoiceId=${invoiceId}`,
  updateInvoice: (invoiceId: string) => `Invoice/${invoiceId}`,
  createInvoice: 'Invoice',
  createReceiptWithAttachments: 'Receipt',
  filterReceipts: (companyId: string) => `Receipt/Filter?companyId=${companyId}`,
  linkInvoice: (receiptId: string, invoiceId: string) =>
    `Receipt/${receiptId}/LinkInvoice?invoiceId=${invoiceId}`,
  unlinkInvoice: (receiptId: string) => `Receipt/${receiptId}/unlinkInvoice`,
  getVariance: (companyId: string) => `Variance/Filter?companyId=${companyId}`,
  actionRequiredInvoice: (overBudgetOnly?: boolean) =>
    `Invoice/FilterByActionRequired?overBudgetOnly=${overBudgetOnly}`,
  declineInvoice: 'Invoice/Decline',
  recallInvoice: 'Invoice/Recall',
  submitForApprovalInvoice: 'Invoice/SubmitForApproval',
  changeInvoicePoAssignment: (invoiceId?: number) => `Invoice/${invoiceId}/ChangePo`,
  changeReceiptPoAssignment: (receiptId?: number) => `Receipt/${receiptId}/ChangePo`,
  getReceiptNotes: 'Receipt/ItemNotes',
  getReceiptLineItems: (receiptId: number) => `Receipt/${receiptId}/LineItems`,
  deleteReceiptLineItem: (receiptId: number, lineItemId: number) =>
    `Receipt/${receiptId}/LineItem/${lineItemId}`,
  getInvoiceLineItems: (invoiceId: string) => `Invoice/${invoiceId}/lineItems`,
  getPoLineItems: (poId: number) => `po/${poId}/lineItems/filter`,
  getPoGlMismatchLineItems: (poId: number) => `Po/${poId}/mismatchGlCodes`,
  companyInvoiceScans: 'Invoice/CompanyInvoiceScans',
  companyReceiptScans: 'Receipt/CompanyReceiptScans',
  getPoDocument: (poId: string) => `po/${poId}/documents`,
  glPeriod: (companyId: string) => `GLCode/GlPeriods?companyId=${companyId}`,
  glCodesBudget: (companyId: string, glPeriodId?: number) =>
    `GLCode/Filter?glPeriodId=${glPeriodId}&companyId=${companyId}`,
  getActualizedAmount: (glCodeId: number, glPeriodId: number) =>
    `GLCode/${glCodeId}/SpentAmtTransactionLog?glPeriodId=${glPeriodId}`,
  getMultiPeriodAllocation: (poId: string) => `PO/${poId}/MultiPeriodAllocations`,
  getGlCodeSummary: (poId: string) => `PO/${poId}/GlCodeSummary`,
  approveInvoice: 'Invoice/Approve',
  getHoldAmount: (glCodeId: number, glPeriodId: number) =>
    `GLCode/${glCodeId}/HoldAmtTransactionLog?glPeriodId=${glPeriodId}`,
  getCommittedAmount: (glCodeId: number, glPeriodId: number) =>
    `GLCode/${glCodeId}/CommittedAmtTransactionLog?glPeriodId=${glPeriodId}`,
  updateReceipt: (receiptId: string) => `Receipt/${receiptId}`,
  glCodePeriodBudget: (companyId: string, glPeriodId?: number) =>
    `GLCode/GLBudgetsByPeriod?glPeriodId=${glPeriodId}&companyId=${companyId}`,
  glCodesBudgetByYear: (companyId: string, fiscalYear?: number) =>
    `GLCode/GlBudgetsbyyear?fiscalYear=${fiscalYear}&companyId=${companyId}`,
  glCodeDepartment: (companyId: string) => `GLCode/Departments?companyId=${companyId}`,
  undeleteGLCode: (companyId: string) => `GLCode/UnDelete?companyId=${companyId}`,
  journalEntry: (glCdId: string, companyId: string) =>
    `GLCode/${glCdId}/JournalEntry?companyId=${companyId}`,
  saveGLCode: (companyId: string) => `GLCode?companyId=${companyId}`,
  deleteGLCode: (companyId: string) => `GLCode/Delete?companyId=${companyId}`,
  deleteDepartment: (companyId: string) => `Department/Delete?companyId=${companyId}`,
  GLPeriodTransaction: (glPeriodId: number, glCdId?: number) =>
    `GLPeriod/${glPeriodId}/TransactionLog?glCdId=${glCdId ?? ''}`,
  department: (companyId: string) => `Department?companyId=${companyId}`,
  addDepartment: (companyId: number) => `Department?companyId=${companyId}`,
  client: (companyId: string) => `Client?companyId=${companyId}`,
  copyDepartment: (companyId: number, departmentId: number) =>
    `Department/${departmentId}/Duplicate?companyId=${companyId}`,
  copyFromDepartment: (companyId: string, departmentId: number) =>
    `Department/CopyFrom?sourceDepartmentId=${departmentId}&companyId=${companyId}`,
  updateDepartment: (departmentId: number, companyId?: string) =>
    `Department/${departmentId}?companyId=${companyId}`,
  getGLCodes: (companyId: string, glPeriodId?: string) =>
    `GLCode?companyId=${companyId}&glPeriodId=${glPeriodId}`,
  getAllGlCode: (companyId: string) => `GLCode/All?companyId=${companyId}`,
  bulkUpdateMember: (companyId: string) => `Department/BulkUpdateClients?companyId=${companyId}`,
  bulkUpdateGLCode: (companyId: string) => `Department/BulkUpdateGlCodes?companyId=${companyId}`,
  getInvoiceMultiPeriodAllocation: (invoiceId: number) =>
    `Invoice/${invoiceId}/MultiPeriodAllocations`,
  getNearestPeriod: (invoiceId: number) => `Invoice/${invoiceId}/NearestPoPeriod`,
  getInvoiceGlBudgetSummary: (invoiceId: string) => `Invoice/${invoiceId}/RemainingBudgets`,
  getGlMasks: 'GLMask/GetGlMasks',
  getInvalidGLCodes: 'GLMask/GetInvalidGlCodes',
  saveGLCodeFormats: 'GLMask/SaveGLMasks',
  updateGLCodeAttributes: 'GLCode/GLAttributes',
  closeGLPeriod: 'GLPeriod/Close',
  getFiscalYears: (propertyId: number, allProperties: boolean) =>
    `GlTool/GlExportFiscalYears?companyId=${propertyId}&allProperties=${allProperties}`,
  getAllFiscalYears: () => `glperiod/GetFiscalYears`,
  getImportsS3Url: (fileName?: string) => 'GlTool/S3UploadUrl?fileName=' + encodeURIComponent(fileName ?? ''),
  budgetImport: 'GlTool/BudgetImport',
  lastImport: (companyId: string) => 'GLTool/LastImportDetails/' + companyId,
  importExceptions: (importId: number, fileType: string) =>
    `GLTool/ImportExceptionFile?importId=${importId}&fileType=${fileType}`,
  exportGLBudgets: 'GLCode/ExportGLBudgets',
  glCodeDepartments: (companyId: string) => `Glcode/GlCodeDepartments?companyId=${companyId}`,
  getAccrualReport: (companyId: string, glPeriodId: number) =>
    `Report/AccrualReport?companyId=${companyId}&glPeriodId=${glPeriodId}`,
  getManagementCompanies: 'client/GetManagementCompanies',
  convertAllocation: (invoiceId: number) => `Invoice/${invoiceId}/ConvertAllocation`,
  getCompanyAttributes: (companyId: number) => `Company/${companyId}/attributes`,
  createCalendarYear: () => `/GLPeriod/CalendarYear`,
  createNoNCalendarYear: `/GLPeriod/NoNCalendarYear`,
  deleteGLPeriod: `/GLPeriod/Delete`,
  reassignCompany: () => `/Invoice/Attach/Reassign`,
  runOcrScan: () => `/Invoice/SubmitForOcr`,
  deleteOcrInvoiceAttachments: () => `/Invoice/DeleteOcrRecords`,
  mergeAttachment: () => `/Invoice/MergeAttachment`,
  getInvoiceMatches: (InvoiceNumber: string, CompanyId: string) =>
    `/Invoice/GetInvoiceMatches?InvoiceNumber=${InvoiceNumber}&CompanyId=${CompanyId}`,
  getOcrCount: (companyId: string, uploadsOlderThan90Days?: boolean) =>
    `/Invoice/GetOcrRecordsCount?companyId=${companyId}&uploadsOlderThan90Days=${uploadsOlderThan90Days}`,
  unDeleteAttachments: () => `/Invoice/UnDeleteAttachments`,
  getPoMatches: (poNumber: string, companyId: string) =>
    `/PO/GetPoMatches?PoNumber=${poNumber}&CompanyId=${companyId}`,

  reviewDocument: () => `/Invoice/ReviewDocument`,
  reviewPo: () => '/Invoice/ReviewPo',
  getOcrFailedMessage: (attachmentId: number) =>
    `/Invoice/GetOcrFailureResponse?attachmentId=${attachmentId}`,
  checkIsExistingOcrDocument: () => `Invoice/CheckIsExistingOcrDocument`,
  getAllSuppliers: (attachmentId: number) => `/Invoice/Attach/${attachmentId}/Suppliers`,
  createOcrDocument: (attachmentId: number) => `Invoice/Attach/${attachmentId}/CreateOcrInvoice`,
  getOcrResponse: (attachmentId: number) => `Invoice/Attach/${attachmentId}/GetOcrResponse`,
  getCatalogs: 'Catalog/GetCatalogs',
  getExternalCatalogs: (catalogId: number) => `Catalog/${catalogId}/PunchoutRedirectUrl`,
  getFavoriteFolders: 'Favourite/GetFavoriteFolders',
  addToFavorites: 'Favourite/AddToFavourites',
  getCatalogCategories: (catalogId: number) => `Catalog/${catalogId}/Categories`,
  updateCart: 'Cart/UpdateCart',
  deleteCart: 'Cart/Delete',
  getCartNotRecommendedItems: 'Cart/NotRecommendedItems',
  updateProduct: 'Product/UpdateProduct',
  getCatalogOfflineSuppliers: (catalogId: number) => `Catalog/${catalogId}/OfflineSuppliers`,
  getProductDetails: (productId: number, catalogId: number, categoryId: number) =>
    `Product/ProductDetails?productId=${productId}&catalogId=${catalogId}&categoryId=${categoryId}`,
  getProducts: 'Product/Filter',
  getCompanyTree: (rootCompanyId: number) => `Company/Tree?rootCompanyId=${rootCompanyId}`,
  getCompanyUsersTree: (companyId: number) => `Company/${companyId}/UsersTree`,
  getCompanySearch: (searchTerm: string, rootCompanyId?: number | null) => {
    const params = [`searchTerm=${encodeURIComponent(searchTerm)}`];
    if (rootCompanyId != null) {
      params.push(`rootCompanyId=${rootCompanyId}`);
    }
    return `Company/Search?${params.join('&')}`;
  },
  getCompanyExportTree: (
    companyId: number,
    searchTerm?: string,
    clientFilter?: 'ShowAll' | 'ShowActive' | 'ShowDisabled',
    companyFilter?: 'ShowAll' | 'ShowActive' | 'ShowDisabled'
  ) => {
    const q = [
      searchTerm && `searchTerm=${encodeURIComponent(searchTerm)}`,
      clientFilter && `clientFilter=${clientFilter}`,
      companyFilter && `companyFilter=${companyFilter}`,
    ]
      .filter(Boolean)
      .join('&');
    return `Company/${companyId}/ExportTree${q ? `?${q}` : ''}`;
  },
  getRecommendedItems: 'ContractedRecommendation/GetRecommendations',
  deletePoLineItem: (poId: number, lineItemId: number, poGridId?: number) =>
    `PO/${poId}/LineItem/${lineItemId}${poGridId ? `?poGridId=${poGridId}` : ''}`,
  updatePoLineItem: 'PO/LineItem',
  createPo: 'PO/Create',
  getPoLineItem: (poId: number, lineItemId: number, itemNum?: string) => {
    const base = `PO/${poId}/LineItems/${lineItemId}`;
    return itemNum ? `${base}?itemNum=${encodeURIComponent(itemNum)}` : base;
  },
  getNotificationUserInfo: 'Client/GetNotificationUserInfo',
  getNotificationEmails: 'Client/GetNotificationEmails',
  updateClientEmail: 'Client/UpdateClientEmail',
  addNotificationEmail: 'Client/AddNotificationEmail',
  updateNotificationEmail: (contactMethodId: string | number) =>
    `Client/UpdateNotificationEmail/${contactMethodId}`,
  deleteNotificationEmail: (contactMethodId: string | number) =>
    `Client/DeleteNotificationEmail/${contactMethodId}`,
  getNotificationTypes: (contactMethodId: string | number) =>
    `Client/GetNotificationTypes?contactMethodId=${contactMethodId}`,
  updateNotificationTypes: 'Client/UpdateNotificationTypes',
  getPOTimingLogs: 'EDIAdmin/GetPOTimingLogs',
  rollBackPOs: 'EDIAdmin/RollBackPOs',
  resendPOs: 'EDIAdmin/ResendPOs',
  exportPOTimingLogs: 'EDIAdmin/ExportPOTimingLogs',
  exportInvoiceLogs: 'EDIAdmin/ExportInvoiceLogs',
  getOutstandingInvoiceLogs: 'EDIAdmin/GetOutstandingInvoiceLogs',
  getEdiUserManual: 'EDIAdmin/UserManual',
  deleteEDIInvoice: 'EDIAdmin/DeleteInvoices',
  getPoNotRecommendedLineItems: (poId: number, lineItemId?: number | null) => {
    const base = `PO/${poId}/NotRecommendedLineItems`;
    return lineItemId ? `${base}?lineItemId=${encodeURIComponent(lineItemId)}` : base;
  },
  message: (clientId: string, sortColumn: string) =>
    `Message?clientId=${clientId}&sortColumn=${sortColumn}`,
  addMessage: (companyId: number) => `Message?companyId=${companyId}`,
  updateMessage: (messageId: number) => `Message/${messageId}`,
  deleteMessage: (messageId: string) => `Message/Delete?companyId=${messageId}`,
  deleteUndeleteMessage: (clientId: string, isDeleteAction: boolean, origin: string) =>
    `/Message/DeleteUndelete/${clientId}/${isDeleteAction}/${origin}`,
};
